module.exports = __webpack_public_path__ + "static/media/Queenie Goldstein 2.935b7959.jpg";